import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

const ROLES = [
  { code: 'ADM', name: 'Administrator' },
  { code: 'MGR', name: 'Manager' },
  { code: 'STF', name: 'Staff' },
];

const LoginPage = () => {
  const [role, setRole] = useState('ADM');
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const { login } = useAuth();
  const toast = useToast();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.username.trim() || !form.password) {
      toast('Please fill in all fields', 'error');
      return;
    }
    setLoading(true);
    try {
      await login(role, form.username.trim(), form.password);
      toast('Welcome back! 🎉', 'success');
      navigate('/');
    } catch (err) {
      if (!err.response) {
        // Network error — common on mobile if backend is slow/down
        toast('Cannot reach server. Check your internet connection.', 'error');
      } else {
        const msg = err.response?.data?.message || 'Login failed. Check your role, username, and password.';
        toast(msg, 'error');
      }
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <img src="/v.png" alt="V2V Superfresh" className="logo-big" />
          <h1>V2V Superfresh ERP</h1>
          <p>Apartment Delivery Management Platform</p>
        </div>

        {/* Role selector */}
        <div className="form-group" style={{ marginBottom: 20 }}>
          <label className="form-label">Select Role Code</label>
          <div className="role-selector">
            {ROLES.map(r => (
              <button
                key={r.code}
                type="button"
                className={`role-btn ${role === r.code ? 'active' : ''}`}
                onClick={() => setRole(r.code)}
              >
                <span className="role-code">{r.code}</span>
                <span className="role-name">{r.name}</span>
              </button>
            ))}
          </div>
        </div>

        <form onSubmit={handleSubmit} className="form-grid" style={{ gap: 16 }}>
          <div className="form-group">
            <label className="form-label">Username</label>
            <input
              id="login-username"
              className="form-input"
              placeholder="Enter your username"
              value={form.username}
              onChange={e => setForm(p => ({ ...p, username: e.target.value }))}
              autoComplete="username"
            />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <div style={{ position: 'relative' }}>
              <input
                id="login-password"
                className="form-input"
                type={showPass ? 'text' : 'password'}
                placeholder="Enter your password"
                value={form.password}
                onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
                style={{ paddingRight: 40 }}
                autoComplete="current-password"
              />
              <button
                type="button"
                onClick={() => setShowPass(p => !p)}
                style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted)' }}
              >
                {showPass ? '🙈' : '👁️'}
              </button>
            </div>
          </div>
          <button
            id="login-submit"
            type="submit"
            className="btn btn-primary"
            disabled={loading}
            style={{ width: '100%', justifyContent: 'center', padding: '12px', fontSize: 15 }}
          >
            {loading ? <><span className="spinner-sm"></span> Signing in...</> : `Sign In as ${role}`}
          </button>
        </form>

        <div style={{ marginTop: 20, padding: '12px', background: 'rgba(99,102,241,0.1)', borderRadius: 8, border: '1px solid rgba(99,102,241,0.2)' }}>
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 4, fontWeight: 600 }}>DEFAULT ADMIN CREDENTIALS</div>
          <div style={{ fontSize: 12, color: 'var(--primary-light)' }}>Role: ADM · Username: admin · Password: admin123</div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
